import { useTheme } from '@mui/material';

export const RealWorldEvidenceIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="10.0802"
                y="11.5611"
                width="26.4638"
                height="26.4164"
                rx="1"
                fill={primaryBackground}
            />
            <path
                d="M5.0936 7.27045C5.50781 7.27045 5.8436 7.60623 5.8436 8.02045V34.2296H32.9696C33.3839 34.2296 33.7196 34.5654 33.7196 34.9796C33.7196 35.3938 33.3839 35.7296 32.9696 35.7296H5.0936C4.67938 35.7296 4.3436 35.3938 4.3436 34.9796V8.02045C4.3436 7.60623 4.67938 7.27045 5.0936 7.27045Z"
                fill={primaryStroke}
            />
            <path
                d="M16.0505 19.1494C16.2494 19.1494 16.4402 19.2284 16.5809 19.369L20.9142 23.7024L24.1768 20.4397C24.4697 20.1468 24.9446 20.1468 25.2375 20.4397C25.5304 20.7326 25.5304 21.2075 25.2375 21.5004L21.4445 25.2934C21.3039 25.434 21.1131 25.513 20.9142 25.513C20.7153 25.513 20.5245 25.434 20.3839 25.2934L16.0505 20.96L9.5823 27.4282C9.28941 27.7211 8.81453 27.7211 8.52164 27.4282C8.22875 27.1354 8.22875 26.6605 8.52164 26.3676L15.5202 19.369C15.6608 19.2284 15.8516 19.1494 16.0505 19.1494Z"
                fill={primaryStroke}
            />
            <path
                d="M32.6421 12.2277C32.935 12.5206 32.935 12.9955 32.6421 13.2884L30.1702 15.7603C29.8773 16.0532 29.4024 16.0532 29.1095 15.7603C28.8166 15.4674 28.8166 14.9926 29.1095 14.6997L31.5815 12.2277C31.8743 11.9348 32.3492 11.9348 32.6421 12.2277Z"
                fill={primaryStroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.1275 18.4668C33.2248 19.1156 32.1176 19.4977 30.9211 19.4977C27.8835 19.4977 25.4211 17.0352 25.4211 13.9977C25.4211 10.9601 27.8835 8.49765 30.9211 8.49765C33.9587 8.49765 36.4211 10.9601 36.4211 13.9977C36.4211 15.2977 35.97 16.4925 35.2158 17.4339L38.4368 20.6549C38.7297 20.9477 38.7297 21.4226 38.4368 21.7155C38.1439 22.0084 37.669 22.0084 37.3761 21.7155L34.1275 18.4668ZM34.9211 13.9977C34.9211 16.2068 33.1302 17.9977 30.9211 17.9977C28.712 17.9977 26.9211 16.2068 26.9211 13.9977C26.9211 11.7885 28.712 9.99765 30.9211 9.99765C33.1302 9.99765 34.9211 11.7885 34.9211 13.9977Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
